module.exports = __webpack_public_path__ + "static/media/subOutlook3.48076d4e.png";